export default {
  init() {

    if ( $('.resource').length < 2 ) {
      $('#resources-section').addClass('filtered');
    } else {
      $('#resources-section').removeClass('filtered');
    }

      $('.resource').each(function(e){
        let reveal = $(this);
        let cnt = $(this).find('.resource-cnt');
        let link = $(this).find('.resource-link');
        let waypoint_reveal = new Waypoint({
          element: reveal[0],
          handler: function(direction) {
            if (direction === 'down'){
              reveal.css('opacity', '1');
              cnt.addClass('cnt-fade-in')
              link.addClass('cnt-fade-in')
            }
          },
          offset: '75%'
        });
      });
//test

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js